<template>
    <div>
        <div>
            {{ reportStatement }} <b>{{ passwordRecommend }}</b>
        </div>
        <pc-input
            id="passwordInput"
            v-model="password"
            type="password"
            v-bind:label="createPasswordLabel"
            v-bind:validator="passwordValidator"
            v-on:validated="passwordValidationResult = $event" />
        <pc-input
            id="passwordConfirm"
            v-model="passwordConfirm"
            type="password"
            v-bind:label="confirmPasswordLabel"
            v-bind:validator="confirmPasswordValidator"
            v-on:validated="confirmPasswordValidationResult = $event" />
        <div>
            {{ passwordProtection }}
        </div>
        <pc-checkbox
            v-model="useWeakEncryption"
            v-bind:label="useWeakerEncryptionLabel" />
    </div>
</template>
}}
<script>
    import { KEYS, NAMESPACE } from "./i18n/sensitiveReportDownloader.i18n";
    import { mapI18n } from "Util/i18n";
    import { VALIDATOR_TYPES, getValidator } from "Validation/validator";

    export const SENSITIVE_DOWNLOADER_RESULT = {
        ok: "OK",
        cancel: "Cancel"
    };

    export default {
        data() {
            return {
                password: "",
                passwordConfirm: "",
                useWeakEncryption: false,
                passwordValidator: getValidator(this.$app, [VALIDATOR_TYPES.password, VALIDATOR_TYPES.required]),
                passwordValidationResult: {},
                confirmPasswordValidationResult: {}
            };
        },
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            ),
            confirmPasswordValidator() {
                return getValidator(this.$app, [
                    VALIDATOR_TYPES.required,
                    {
                        type: VALIDATOR_TYPES.custom,
                        validate: this.isPasswordMatch,
                        errorMsg: this.passwordMismatchMessage,
                        skipTrimValue: true
                    }
                ]);
            },
            hasValidationError() {
                return this.passwordValidationResult.error && this.confirmPasswordValidationResult.error;
            }
        },
        methods: {
            async isValidToClose(dialogResult) {
                if (dialogResult === SENSITIVE_DOWNLOADER_RESULT.ok) {
                    return this.isPasswordMatch() && !this.hasValidationError;
                }
                return true;
            },
            isPasswordMatch() {
                return this.password === this.passwordConfirm;
            },
            resultHook() {
                return {
                    password: this.password,
                    useWeakEncryption: this.useWeakEncryption
                };
            }
        }
    };
</script>
